import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './ChevronRight.styles';

export type ChevronRightIconProps = WithStyles<typeof styles>;

const ChevronRightIconComponent: FC<ChevronRightIconProps> = ({ classes }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path d="M1 9L5 5L1 1" stroke="#828D9E" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const ChevronRightIcon = withStyles(styles)(ChevronRightIconComponent);
